import { render, staticRenderFns } from "./PrepaAdrItemSlide.vue?vue&type=template&id=40da74f5&"
import script from "./PrepaAdrItemSlide.vue?vue&type=script&lang=js&"
export * from "./PrepaAdrItemSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports